
export class OmnisoftCheckData {
  check_type: number;

  constructor(checkType: number) {
    this.check_type = checkType;
  }
}
